import ApiClient from "./ApiClient"

import {User} from "../types/User"

export const UserApi = {

    apiPath: 'users',

    get: async (id: number, include?: string): Promise<User> => {

        let url: string = UserApi.apiPath + '/' + id

        if (include) {
            url += `?include=${include}`
        }

        const response = await ApiClient.get(url)

        return response.data.data
    },

    getAll: async (search?: string): Promise<User[]> => {
        const items: User[] = []
        const params = new URLSearchParams([
            ['lockingSystemId', localStorage.getItem('selectedLockingSystemId') as string]
        ])

        if (search) params.append('search', search)

        const response = await ApiClient.get(UserApi.apiPath, { params });

        for (let item of response.data.data) {
            items.push(item)
        }

        return items
    },

    add: async (newItem: User): Promise<User> => {

        const result = await ApiClient.post(UserApi.apiPath, newItem);

        return result?.data.data
    },

    delete: async(id: number): Promise<any> => {

        return await ApiClient.delete(UserApi.apiPath + '/' + id);

    },

    edit: async (user: User): Promise<User> => {

        const result = await ApiClient.put(UserApi.apiPath + '/' + user.id, user);

        return result?.data.data
    },
}